import { STORIES } from "../data/content";
import Seo from "../components/Seo";

export default function Stories() {
  return (
    <div data-testid="page-stories">
      <Seo
        title="Stories — Field notes from Country"
        description="Most seed organisations have data. SeedKeepers has stories: The Grandmothers, Seed Collection on Country, What Healthy Country Looks Like, Building the Shadehouse."
        path="/stories"
      />
      <section className="border-b border-rule">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
          <p className="section-num mb-4">Stories — Notebook</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] max-w-4xl">
            Most seed organisations have data. <em className="text-eucalypt">We have stories.</em>
          </h1>
        </div>
      </section>

      <section>
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-24 space-y-24">
          {STORIES.map((s, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <article
                key={s.title}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${reverse ? "lg:[direction:rtl]" : ""}`}
                data-testid={`story-${idx}`}
              >
                <div className={`lg:col-span-5 ${reverse ? "lg:[direction:ltr]" : ""}`}>
                  <div className="polaroid">
                    <img src={s.image} alt={s.title} className="w-full h-[420px] object-cover" />
                  </div>
                </div>
                <div className={`lg:col-span-7 ${reverse ? "lg:[direction:ltr]" : ""}`}>
                  <p className="specimen-label mb-3">No. {String(idx + 1).padStart(2, "0")}</p>
                  <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl leading-[1.05] mb-5">{s.title}</h2>
                  <p className="font-serif italic text-xl md:text-2xl text-eucalypt mb-6">"{s.lede}"</p>
                  <p className="text-base text-ink/85 leading-relaxed">{s.body}</p>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
